
export const getEnvVar = (key) => {
  let value;
  if (process.env.NODE_ENV === 'production') {
    value = window.env?.[key];
  } else {
    value = process.env[`REACT_APP_${key}`];
  }
  
  // Check if value is a placeholder that wasn't replaced (deployment issue)
  if (value && typeof value === 'string' && value.includes('__STACKGUARD_') && value.includes('__')) {
    console.error(`Environment variable ${key} is not properly configured. Got placeholder: ${value}`);
    // Return undefined to trigger fallback or error handling
    return undefined;
  }
  
  if (value && typeof value === 'string' && key.includes('URL') && !value.endsWith('/')) {
    return value + '/';
  }
  
  return value;
};

// Base URLs with safe fallbacks so URL() always gets a valid absolute URL
const rawApiUrl = getEnvVar('STACKGUARD_API_URL');
const browserOrigin =
  typeof window !== 'undefined' ? window.location.origin + '/' : '';
const resolvedApiUrl = rawApiUrl || browserOrigin;

// Pre-configured environment variables
export const ENV = {
  API_URL: resolvedApiUrl,
  AI_URL: getEnvVar('STACKGUARD_AI_URL'),
  // Legacy support
  REACT_APP_URL: resolvedApiUrl,
  REACT_APP_AI_URL: getEnvVar('STACKGUARD_AI_URL')
};

